import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import {
  CreatePayrollResultDocument,
  CreatePayrollResultMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import ImportSummaryNavigationTabs from 'modules/payroll_bundle/components/PayrollSummaryImport/PayrollSummaryImportModal/ImportSummaryWizard/_steps/_common/header'
import { generateResultConceptItems } from 'modules/payroll_bundle/components/PayrollSummaryImport/PayrollSummaryImportModal/ImportSummaryWizard/tools'
import { WizardData } from 'modules/payroll_bundle/components/PayrollSummaryImport/PayrollSummaryImportModal/ImportSummaryWizard/types'
import { ImportData } from 'modules/payroll_bundle/lib/PayrollResultContext'

import EmployeeMatcher from './EmployeeMatcher'

const ReviewAndImportStep = ({ data, onDataChanged }: WizardStepRenderParams<WizardData>) => {
  const currency = data.currency
  const worksheetMatches = data.worksheetMatches
  const labelToConceptId = data.labelToConceptId
  const [createPayrollResult] = useMutation(CreatePayrollResultDocument, {
    extractorFn: (data: CreatePayrollResultMutation) => data.payrollMutations.createPayrollResult,
  })

  const onUpdateData = (importedData: {
    importedData: ImportData[]
    employeesSelected: Set<number>
  }) => {
    onDataChanged({
      ...data,
      importedData: importedData.importedData,
      employeesSelected: importedData.employeesSelected,
    })
  }

  const handleNext = async () => {
    if (
      !data.importedData ||
      !data.employeesSelected ||
      !data.labelToConceptId ||
      !data.company ||
      !data.access ||
      !data.payrollSummaryImport
    )
      return

    const resultConceptItems = generateResultConceptItems(
      data.importedData,
      data.employeesSelected,
      data.labelToConceptId
    )

    const result = await createPayrollResult({
      variables: {
        authorId: data.access.id,
        companyId: data.company.id,
        concept: data.payrollSummaryImport.compensationType,
        filename: data.payrollSummaryImport.fileName,
        payrollPolicyPeriodId: data.payrollPolicyPeriod.id,
        resultConceptItems,
        selectedFields: '',
      },
    })

    const resultMutation = handleResult(result, () => {})

    if (resultMutation.success) {
      track(trackingEvents.payroll.confirmImportResults, {
        period_status: data.payrollPolicyPeriod.status,
        number_of_results: data.importedData.length,
        source: data.source,
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
      return Promise.reject()
    }

    return resultMutation.success
  }

  useOnNext(handleNext)

  return (
    <Box gap="s24" overflowY="hidden">
      <ImportSummaryNavigationTabs selectedStep={2} />

      <Text.Normal>
        {i18n.t('payroll_bundle.payroll_summary_import.wizard.review_and_import_step.description')}
      </Text.Normal>

      {currency && labelToConceptId && worksheetMatches && (
        <EmployeeMatcher
          currency={currency}
          worksheetMatches={worksheetMatches}
          payrollSummaryImport={data.payrollSummaryImport}
          payrollPolicyPeriodId={data.payrollPolicyPeriod.id}
          labelToConceptId={labelToConceptId}
          onUpdateData={onUpdateData}
        />
      )}
    </Box>
  )
}

export default ReviewAndImportStep
